import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-transfer',
  storeModule.createStoreModule('real-estate-developments-transfer')
)
